import Swal from 'sweetalert2';
import { getMoistureDailyCount } from '../services/MoistureCorrectionServices';

export async function confirmMoistureSoftLimit(cookies, plantId, actionLabel = 'save') {
  if (!plantId) {
    return true;
  }
  try {
    const meta = await getMoistureDailyCount(cookies, plantId);
    if (meta?.soft_limit_reached) {
      const result = await Swal.fire({
        title: `${meta.daily_count} corrections already saved today`,
        html: `Recommended limit is <b>${meta.soft_limit}</b> per day for climate-based checks.<br/>Do you want to ${actionLabel} another correction?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, continue',
        cancelButtonText: 'Cancel',
      });
      return result.isConfirmed;
    }
  } catch (error) {
    console.error('Unable to check moisture daily count', error);
  }
  return true;
}

export function formatMoistureDailyCount(meta) {
  if (!meta || meta.daily_count === undefined) {
    return '';
  }
  const limit = meta.soft_limit ?? 3;
  return `Corrections today: ${meta.daily_count} / ${limit}`;
}
